// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--8a73b";
export var contents = "style-module--contents--0b851";
export var imageContainer = "style-module--imageContainer--92d51";
export var imageWithText = "style-module--imageWithText--a30c3";